import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../../store/views/entityView";
import { messagesByStudyGroupsBoardQuery } from "../../../../../utils/entitiesFiltersUtils";
import Widget from "../../../../features/widget/Widget";
import ScrollLTR from "../../../../ui/scrollLTR/ScrollLTR";
import Message from "../../../../features/message/Message";
import boardType from "../../../../../enums/boardType";
import Scroll from "../../../../ui/scroll/Scroll";
import iconsList from "../../../../ui/icons/iconsList";
import noMessagesImg from "../../../../../../assests/emptyList/message.png";
import classes from "./MessagesDomainWidget.module.css";

const MessagesDomainWidget = ({ studyGroupIds = [] }) => {

    const listRef = useRef(null);
    const { texts, lang } = useSelector(state => state.translate);
    const messages = useSelector(state => selectEntitiesByFilters(state, messagesByStudyGroupsBoardQuery(lang, studyGroupIds, boardType.messagesByNmm)));

    return (
        <Widget
            color="#BBA9E0"
            title={texts.messagesBoard}
            icon={iconsList.messages}
            className={classes.MessagesWidget}
            contentScrollable={false}
        >
            {messages?.length > 0 ? (
                <Scroll height="100%">
                    <div className={classes.MessagesList} ref={listRef}>
                        {messages.map(message => (
                            <Message key={message.id} {...message} />
                        ))}
                    </div>
                </Scroll>
            ) : (
                <div className={classes.NoMessages}>
                    {texts.noMessages}
                    <img src={noMessagesImg} alt={texts.noMessages} className={classes.EmptyImage} />
                </div>
            )}
        </Widget>
    );
};

export default MessagesDomainWidget;
